import React, { useState } from 'react';
import { Section } from './Section';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  question: '¿Cuánto dura la batería?',
  answer: 'La batería dura hasta 20 horas en la intensidad más baja y aproximadamente 6 horas en la intensidad máxima. Cuenta con un indicador digital en pantalla para que sepas en todo momento cuánta carga te queda.'
}, {
  question: '¿Cuánto tiempo tarda en cargar?',
  answer: 'Se carga completamente en aproximadamente 2 horas mediante el cable USB-C incluido.'
}, {
  question: '¿Cuánto pesa?',
  answer: 'Pesa solo 165 gramos. Su diseño ergonómico se adapta al cuello y apenas la sentís puesta, incluso después de varias horas de uso.'
}, {
  question: '¿En qué colores está disponible?',
  answer: 'La luz está disponible únicamente en color Negro mate, con detalles sutiles y terminación premium.'
}, {
  question: '¿Cuántas intensidades y tonos de luz tiene?',
  answer: 'Cuenta con 3 niveles de intensidad y 3 tonos de color: cálida, neutra y blanca. Podés combinarlos para adaptarte a cualquier momento del día o tarea.'
}, {
  question: '¿Cómo es el envío y cuánto tarda?',
  answer: 'Comprando 2 unidades o más, el envío es totalmente gratis. En compras de 1 unidad se realiza por correo tradicional con un costo accesible. Los tiempos de entrega son los habituales del Correo Argentino, según tu ubicación.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section data-id="element-18">
      <div className="max-w-3xl mx-auto" data-id="element-19">
        <div className="mb-16 text-center" data-id="element-20">
          <p className="text-sm font-medium text-[#FF6B1A] tracking-widest uppercase mb-4" data-id="element-21">
            FAQ
          </p>
          <h2 className="text-3xl md:text-5xl font-light tracking-tight text-balance" data-id="element-22">
            Preguntas frecuentes
          </h2>
        </div>

        <div className="flex flex-col" data-id="element-23">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="border-b border-black/10" data-id="element-24">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-center justify-between py-6 text-left focus:outline-none group" aria-expanded={isOpen} data-id="element-25">
                  <span className={`text-lg font-medium pr-6 transition-colors ${isOpen ? 'text-[#FF6B1A]' : 'group-hover:text-[#FF6B1A]'}`} data-id="element-26">
                    {faq.question}
                  </span>
                  <span className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-all ${isOpen ? 'bg-[#FF6B1A] text-white rotate-180' : 'bg-black/5 text-[#0A0A0A] group-hover:bg-[#FF6B1A]/10'}`} data-id="element-27">
                    {isOpen ? <Minus size={16} strokeWidth={2} data-id="element-28" /> : <Plus size={16} strokeWidth={2} data-id="element-29" />}
                  </span>
                </button>

                <AnimatePresence data-id="element-30">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-31">
                      <p className="pb-6 text-[#6B6B6B] font-light leading-relaxed text-base pr-12" data-id="element-32">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </Section>;
}